namespace SP {
    export interface PickListLineData {
        pickLineInfo: PickLineInfo;
        stockingLotInfo: StockingLotInfo;
        imageUrl: string;
        extraText: string;
        orderWarehouseNotificationPacker: string;
        orderWarehouseNotificationPicker: string;
    }
}